module.exports = __webpack_public_path__ + "img/623.4ecb2637.png";